module.exports = __webpack_public_path__ + "static/media/0268_Medium.001128fd.jpg";